import {Stack, Title, Group, ActionIcon, Tooltip} from "@mantine/core";
import {Link, Outlet, useParams} from "react-router-dom";
import { partHooks } from "features/parts";
import {LoaderDefault, NoData} from "components/common";
import {DefaultPageWrapper} from "layouts";
import {ArrowLeft} from "tabler-icons-react";
import {RoutesResolver} from "routes";

export function Part() {
    const { partId } = useParams();
    const {isLoading, data: part } = partHooks.useGetById(parseInt(partId!), {

    });

    function renderContent() {
        if (isLoading) {
            return <LoaderDefault text="Loading Part"/>
        } else if (!part) {
            return <NoData title="No Part with specified ID found"/>
        } else {
            return <Outlet/>
        }
    }

    const routesResolver = new RoutesResolver();

    return (
        <Stack spacing={0}>
            <DefaultPageWrapper>
                <Group spacing="sm">
                    <Tooltip label="Back to Parts" withArrow>
                        <ActionIcon component={Link} size="sm" to={ routesResolver.parts }>
                            <ArrowLeft size={18}/>
                        </ActionIcon>
                    </Tooltip>
                    <Title>Insert Part Title Attribute</Title>
                </Group>
            </DefaultPageWrapper>
            <Stack>
                {renderContent()}
            </Stack>
        </Stack>
    )

}
